const styles = (theme) => ({
	containerCustomTooltip: {
		bgcolor: theme.palette.paletteCharts.lineCharts,
		padding: "8px",
		borderRadius: "8px",
		boxShadow: `0px 2px 4px ${theme.palette.colors.black.darker}33`,
		minWidth: "120px",
		minHeight: "48px",
	},
	title: {
		fontWeight: 600,
		fontSize: "15px",
	},
});

export default styles;
